import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Button } from "antd";
import Switch from "@material-ui/core/Switch";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";

const CategoryOption = ["10", "15", "20"];

export default function NftSellingDetailsStep({
  nftDetails,
  onClickRoyalty,
  formStep,
  steps,
  prev,
  next,
  setnftDetails,
  bsvRate,
}) {
  const renderStepperActions = () => {
    const { royalty } = nftDetails;

    return (
      <>
        {formStep > 0 && (
          <Button
            className="step_btn_btn"
            style={{ margin: "0 8px" }}
            onClick={() => prev()}
          >
            Prev
          </Button>
        )}
        {formStep < steps.length - 1 && (
          <Button
            className="step_btn_btn"
            disabled={!royalty}
            type="primary"
            onClick={() => next()}
          >
            Next
          </Button>
        )}
      </>
    );
  };
  return (
    <>
      <div className="row steps-content-inner-wrapper">
        <div className="w-full px-4 text-left">
          <h4 className="sign__title">NFT royalty details</h4>
        </div>

        <div className="w-full px-4 mt-2">
          <div className="sign__group royalty_box_wrapper">
            <label className="sign__label" htmlFor="nft-royalty">
              Royalty (%) <span className="text-red-500">*</span>
              <Tooltip
                enterTouchDelay={0}
                title="A royalty is the % of the selling price that will be received by the minter of NFT every time the NFT is resold."
              >
                <HelpIcon
                  style={{
                    fontSize: 18,
                    marginLeft: 10,
                    position: "absolute",
                  }}
                />
              </Tooltip>
            </label>

            <div className="royalty_btn_box">
              {CategoryOption.map((category, index) => (
                <Button
                  key={index}
                  type="royalty"
                  name="royalty"
                  onClick={(e) =>
                    onClickRoyalty(
                      { target: { name: "royalty" } },
                      true,
                      category
                    )
                  }
                  value={nftDetails.royalty}
                  required="required"
                  className={`royalty__btn ${
                    nftDetails.royalty === category
                      ? "royalty__btn__selected"
                      : ""
                  }`}
                >
                  {category}%
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="steps-action px-4">{renderStepperActions()}</div>
    </>
  );
}
